import React from 'react'
import useScrollReveal from '../../hooks/useScrollReveal'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCheck } from '@fortawesome/free-solid-svg-icons'

const FREE_FEATURES = [
  'Comptes illimités',
  'Transactions illimitées',
  'Partage de comptes',
  'Échéanciers récurrents',
  'Import CSV',
  'Dashboard & Analytics',
  'Tickets de caisse',
]

export default function Pricing() {
  const [ref, isVisible] = useScrollReveal()

  return (
    <section id="pricing" className={`section-padding reveal${isVisible ? ' revealed' : ''}`} ref={ref}>
      <h2 className="section-title">Simple et transparent.</h2>
      <p className="section-subtitle">Commencez gratuitement, évoluez à votre rythme.</p>

      <div className="landing-pricing">
        <div className="landing-pricing__card">
          <div className="landing-pricing__plan-name">Gratuit</div>
          <div className="landing-pricing__price">0 €</div>
          <div className="landing-pricing__period">pour toujours</div>

          <ul className="landing-pricing__features">
            {FREE_FEATURES.map((feature, i) => (
              <li className="landing-pricing__feature" key={i}>
                <FontAwesomeIcon icon={faCheck} />
                {feature}
              </li>
            ))}
          </ul>

          <a href={process.env.REACT_APP_APP_URL + '/nouveau_compte'} className="landing-pricing__cta">
            Commencer gratuitement
          </a>
        </div>
      </div>
    </section>
  )
}
